import React from "react";
import moment from "moment";

class Footer extends React.Component {
	render() {
		return (
			<footer className="site-footer">
				<p className="tagline">
					Official cycling website for Bristol, Bath & NE Somerset, North
					Somerset and South Gloucestershire.
				</p>

				<ul className="footer-list">
					<li>
						<a href={ `${ window.WEBSITE_ROOT }/terms-conditions` }>
							Terms &amp; Conditions
						</a>
					</li>
					<li>
						<a href={ `${ window.WEBSITE_ROOT }/privacy-policy` }>Privacy Policy</a>
					</li>
					<li>
						<a href={ `${ window.WEBSITE_ROOT }/accessibility` }>Accessibility</a>
					</li>
					<li className="small-content">
						<a href="mailto:betterbybike@bristol.gov.uk">Feedback</a>
					</li>
				</ul>

				<p className="footer-copyright">
					&copy; betterbybike.info { moment().format("YYYY") }. All Rights
					Reserved.
				</p>

				<p className="tagline">Powered by</p>
				<div className="footer-image-wrapper">
					<img
						src="/images/cycle-streets-logo.png"
						alt="Cycle Streets logo"
						width="80"
					/>
					<img
						src="/images/opendata-logo.png"
						alt="Open Data Bristol logo"
						width="80"
					/>
				</div>
			</footer>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js